import { lazy } from "react";
import { IRouteDefinition, ISubModuleRoutes } from "../routing";

export enum CommonRouteId {
    CommonFrontPage = "front-page",
    LoginExpiredPage = "login-expired-page",
    PageNotFoundPage = "page-not-found-page"
}

export const commonRoutes: IRouteDefinition[] = [
    {
        id: CommonRouteId.CommonFrontPage,
        exact: true,
        path: "/",
        component: lazy(() => import(/* webpackChunkName: 'FrontPage' */"./views/FrontPage"))
    },
    {
        id: CommonRouteId.LoginExpiredPage,
        exact: true,
        requireAuth: false,
        path: "/istunto_vanhentunut",
        component: lazy(() => import(/* webpackChunkName: 'LoginExpiredPage' */"./views/LoginExpiredPage"))
    },
    {
        id: CommonRouteId.PageNotFoundPage,
        exact: true,
        requireAuth: false,
        path: "",
        component: lazy(() => import(/* webpackChunkName: 'LoginExpiredPage' */"./views/PageNotFoundPage"))
    }
]

const CommonRouting: ISubModuleRoutes = {
    prefix: "",
    routes: commonRoutes,
    template: null,
    routeId: CommonRouteId
}

export default CommonRouting

